import DOMPurify from 'dompurify';

const SAFE_DATA_URI_REGEX = /^data:image\/(?:[a-z0-9.+-]+);base64,[A-Za-z0-9+/=\s]+$/i;

const RICH_TEXT_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'ul', 'ol', 'li', 'strong', 'em', 'b', 'i', 'u',
    'blockquote', 'code', 'pre', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'figure', 'figcaption', 'img'
  ],
  ALLOWED_ATTR: {
    a: ['href', 'title', 'target', 'rel'],
    code: ['class'],
    figure: ['class'],
    img: ['src', 'alt', 'title', 'width', 'height']
  },
  ALLOW_DATA_ATTR: false,
  ALLOW_DATA_URI: true,
  ADD_URI_SAFE_REGEXP: /^data:image\/(?:[a-z0-9.+-]+);base64,/i,
  FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed', 'template'],
  FORBID_ATTR: ['style', 'onerror', 'onclick', 'onload', 'onmouseover']
};

const ensureSafeLinkAttributes = (node) => {
  if (node.tagName === 'A') {
    const rel = node.getAttribute('rel') || '';
    const tokens = new Set(rel.split(/\s+/).filter(Boolean));
    tokens.add('noopener');
    tokens.add('noreferrer');
    tokens.add('nofollow');
    node.setAttribute('rel', Array.from(tokens).join(' '));
  }
};

export const sanitizeRichText = (value = '') => {
  if (!value) {
    return '';
  }

  DOMPurify.addHook('afterSanitizeAttributes', ensureSafeLinkAttributes);
  try {
    return DOMPurify.sanitize(value, RICH_TEXT_CONFIG);
  } finally {
    DOMPurify.removeHook('afterSanitizeAttributes');
  }
};

export const sanitizePlainText = (value = '') => {
  if (!value) {
    return '';
  }
  return DOMPurify.sanitize(value, { ALLOWED_TAGS: [], ALLOWED_ATTR: {} });
};

export default sanitizeRichText;
